import { render } from "./EditClientContract.vue?vue&type=template&id=5b02a400&scoped=true"
import script from "./EditClientContract.vue?vue&type=script&lang=js"
export * from "./EditClientContract.vue?vue&type=script&lang=js"

import "./EditClientContract.vue?vue&type=style&index=0&id=5b02a400&scoped=true&lang=css"

import exportComponent from "D:\\Work\\Contractly\\Contractly.Site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b02a400"]])

export default __exports__